<template>
    <li :class="getProprieties()">

        <router-link :to="link  " v-if="submenu === undefined && link !== undefined">
            <span class="icon">
                <i class="fa" :class="`fa-${icon}`"></i>
            </span>
            {{menuText}}
        </router-link>

        <a v-if="!submenu && !link && action" @click="action">
            <span class="icon">
                <i class="fa" :class="`fa-${icon}`"></i>
            </span>
            {{menuText}}
        </a>

        <a v-if="submenu != undefined" @click="opened=!opened">
            <span class="icon">
                <i class="fa" :class="`fa-${icon}`"></i>
            </span>
            {{menuText}}

            <i v-if="submenu != undefined" class="fa" :class="!opened ? 'fa-angle-down' : 'fa-angle-up'"></i>
        </a>

        <ul v-if="submenu != undefined">
            <slot></slot>
        </ul>
    </li>
</template>

<style lang="scss" scoped>
    @import '../css/components/MenuItem';
</style>


<script>
    export default {
        name: 'Alert',

        props: ['color','submenu','menuText','link','icon','action'],

        data: () => ({
            opened: false,
        }),

        methods: {
            close(e) {
                if (!this.$el.contains(e.target)) {
                    this.opened = false
                }
            },

            getProprieties() {
                const color = `is-${this.color}`,
                    opened = this.opened ? 'is-opened' : '',
                    hasSubmenu = (this.submenu !== undefined) ? 'has-submenu' : '';

                return `${color} ${opened} ${hasSubmenu}`;
            },
        },

        created() {
            window.addEventListener('click', this.close)
        },

        beforeDestroy() {
            window.removeEventListener('click', this.close)
        },
    }
</script>